
const animate = ({timing, draw, duration}) => {
    let t0 = performance.now();

    requestAnimationFrame(function animate(t) {
        if(t0 > t) t0 = t;
        let timeFraction = (t - t0) / duration;
        if(timeFraction > 1) timeFraction = 1;

        const progress = timing(timeFraction);

        draw(progress);

        if(timeFraction < 1) requestAnimationFrame(animate);
    })
}

export default animate;